import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const CircularPlus = ({
  size = 60,
  style = {},
  color = "#003125",
}: PropsType) => {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30" cy="30" r="25" stroke={color} stroke-width="4" />
      <path
        d="M18 30H42"
        stroke={color}
        stroke-width="4"
        stroke-linecap="round"
      />
      <path
        d="M30 18V42"
        stroke={color}
        stroke-width="4"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default CircularPlus;
